import en from './strings.en';

const ru = {
    cityFrom: 'Откуда',
    cityTo: 'Куда',
    carTypes: 'Тип кузова',
    carryingCapacity: 'Грузоподъёмность',
    bodyVolume: 'Объём кузова',
    tons: 'т',
    meters: 'м',
    free: 'Бесплатно',
    outsideRussia: ' для направлений вне РФ. ',
    try: 'Попробуйте: '
};

export default { ru, en: { ...ru, ...en} };
